/*
|-------------------------------------------------------------------------------
| VUEX modules/truckRunnings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import TruckRunningSettingAPI from '../api/truckRunningSetting.js';

export const truckRunningSettings = {
    state: {
        truckRunningSetting: {},
        truckRunningSettingLoadStatus: 0,

        truckRunningSettingAddStatus: 0,

        truckRunningSettingUpdateStatus: 0,
    },

    actions: {
        loadTruckRunningSetting ( { commit } ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningSettingLoadStatus', 1 );

                TruckRunningSettingAPI.get()
                    .then( function( response ){
                        commit( 'setTruckRunningSetting', response.data.data);
                        commit( 'setTruckRunningSettingLoadStatus', 2 );
                        resolve(response);
                    })
                    .catch( function(error){
                        commit( 'setTruckRunningSetting', {} );
                        commit( 'setTruckRunningSettingLoadStatus', 3 );
                        reject();
                    });
            });
        },
        addTruckRunningSetting ( { commit }, data ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningSettingAddStatus', 1 );

                TruckRunningSettingAPI.post( data )
                    .then( function( response ){
                        console.log(response);
                        commit( 'setTruckRunningSettingAddStatus', 2 );
                        resolve();
                    })
                    .catch( function( error ){
                        commit( 'setTruckRunningSettingAddStatus', 3 );
                        reject();
                    });
            });
        },
        updateTruckRunningSetting ( { commit, dispatch }, data ){
            return new Promise((resolve, reject) => {
                commit( 'setTruckRunningSettingUpdateStatus', 1 );

                TruckRunningSettingAPI.put( data )
                    .then( function( response ){
                        commit( 'setTruckRunningSettingUpdateStatus', 2 );
                        dispatch('loadTruckRunningSetting');
                        resolve();
                    })
                    .catch( function( error ){
                        commit( 'setTruckRunningSettingUpdateStatus', 3 );
                        reject();
                    });
            });
        }
    },

    mutations: {
        setTruckRunningSetting( state, truckRunningSetting ){
            state.truckRunningSetting = truckRunningSetting;
        },
        setTruckRunningSettingLoadStatus( state, status ){
            state.truckRunningSettingLoadStatus = status;
        },
        setTruckRunningSettingAddStatus( state, status ){
            state.truckRunningSettingAddStatus = status;
        },
        setTruckRunningSettingUpdateStatus( state, status ){
            state.truckRunningSettingUpdateStatus = status;
        },
    },

    getters: {
        getTruckRunningSettingLoadStatus( state ){
            return state.truckRunningSettingLoadStatus;
        },
        getTruckRunningSetting( state ){
            return state.truckRunningSetting;
        },
        getTruckRunningSettingAddStatus( state ){
            return state.truckRunningSettingAddStatus;
        },
        getTruckRunningSettingUpdateStatus( state ){
            return state.truckRunningSettingUpdateStatus;
        },
        getIfSettingHasAccess( state ){
            if (state.truckRunningSetting) {
                return Boolean(state.truckRunningSetting.has_access);
            }
            return false;
        }
    },
};

/**
 * Helpers
 */